import './CustomPictureSlider.scss';
import Slider from "react-slick";
import React, { useState, useRef } from 'react';

export default function CustomPictureSlider({card}) {
    const [isWhite, setWhite] = useState({white: true});
    const wRef = useRef(null);
    const wRefDay = useRef(null);
    const onClick = (ev) => {
        if (ev.target === wRef.current || ev.target === wRefDay.current) {
            setWhite(true)
        } else {
            setWhite(false);
        }
    }

    let SliderWhite = card.sliderWhite.map ((src, idx) =>
        { 
            return (
                <img loading="lazy" key={idx} className="pic" alt = "" src = {src.src} ></img>
            )
        }
    )
    let SliderBlack = card.sliderBlack.map ((src, idx) =>
        { 
            return (
                <img loading="lazy" key={idx} className="pic" alt = "" src = {src.src} ></img>
            )
        }
    )
    const settingsWhite = {
        customPaging: function(i) {
            return (
                <img loading="lazy" src = {`/img/pictureslider${card.id}${i+ 1}.png`} alt="" />
            );
        },
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: "slick-dots slick-thumb"
    };
    const settingsBlack = {
        customPaging: function(i) {
            return (
                <img loading="lazy" src = {`/img/pictureslider${card.id}${i+ 5}.png`} alt="" />
            );
        },
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: "slick-dots slick-thumb"
    };
    return (
        <div className='custom__picture-slider'>
            <div className='description'>
                <div className='description__title'>
                    Sennheiser
                </div>
                <div className='description__subtitle'>
                    {card.subtitle}
                </div>
            </div>
            {isWhite ? 
            (
                <Slider {...settingsWhite}>
                    {SliderWhite}
                </Slider>
            )
            : (
                <Slider {...settingsBlack}>
                    {SliderBlack}
                </Slider>
            )}
            <div className="colors-group">
                <div ref={wRef} onClick={onClick} className={isWhite ? "color white active": "color white"}>
                    
                </div>
                <div onClick={onClick} className={isWhite ? "color black": "color black active"}>

                </div>
            </div>
        </div>
    )
}

